import TrackerFilterPopoverGrid from './TrackerFilterPopoverGrid';
import { TrackerFilterStatus } from './types';
import StatusInputSelection from '../../shared/inputs/StatusInputSelection';
import {
  DropdownTableAutocompleteOption,
  DropdownTableAutocompleteOptionStatus,
} from '../../shared/contexts/DropdownTableContext';
import { trackerFilterStatusChipTypographySx } from './trackerFilterToolbarStyles';

interface TrackerFilterStatusSelectionProps {
  selectedStatus: TrackerFilterStatus[];
  onSelect: (selectedStatus: TrackerFilterStatus[]) => void;
  options: DropdownTableAutocompleteOption[];
}

export default function TrackerFilterStatusSelection(props: TrackerFilterStatusSelectionProps) {
  const { selectedStatus, onSelect, options } = props;

  return (
    <TrackerFilterPopoverGrid>
      STATUS
      <StatusInputSelection
        options={options.map((option) => (option as DropdownTableAutocompleteOptionStatus).name)}
        isFilterModal
        selectedStatus={selectedStatus.map((statusObj) => statusObj.name)}
        onSelect={(statusNames) =>
          onSelect(
            statusNames.map((statusName) => {
              return { name: statusName };
            })
          )
        }
        multiSelect
        chipSx={trackerFilterStatusChipTypographySx}
      />
    </TrackerFilterPopoverGrid>
  );
}
